import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Hourglass.scss';
const Hourglass = ({ size = 40, color = 'black', speed = 1.75, bgOpacity = 0.1, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-bg-opacity': bgOpacity + '',
        }, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.half }), _jsx("div", { className: styles.half })] }) }));
};
export default Hourglass;
